import React,{useState, useEffect} from 'react';
import {connect} from 'react-redux';
// import {push} from 'connected-react-router'
import {paymentPreviewSelect} from '../../redux/selector/paymentPreviewSelector'
import {
    Header, 
    Button,
    ErrorMark,
    NavigationLinkButton,
} from '../../components/RegularComponents'
import Navigation from '../Navigation';
import { 
    computeCost, 
    financialNumber, 
    replaceUrlParams 
} from '../../app/utils';
import TopNavigationBar from '../TopNavigationBar';
import { fetchApplicationReferenceData } from '../../redux/slice/primaryAgencyApplicationSlice'
import { 
    initiatePayment_v1,
    processApplicationResponse,
} from '../../redux/slice/collectionApplicationSlice';
import { 
    APPLICATION_STATUS_PENDING_PAYMENT,
    // APPLICATION_MODE_RENEW, 
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY, 
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL, 
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL, 
    PAYMENT_STATUS_FAILURE, 
    PAYMENT_STATUS_INPROGRESS, 
    ROUTE_PATH, 
    SEGUE_NAME 
} from '../../app/constants';
import { push } from 'connected-react-router';
import { saveSegueDetails } from '../../redux/slice/primaryAgencyApplicationSlice';
import { ERROR_STRING } from '../../app/errors';
import { fetchApplicationWithId } from '../../redux/slice/bltHomeSlice';

const PaymentPreview = (props) => { 
    const { paymentPreview,dispatch } = props
    const { applicationType, applicationMode } = props.match.params
    const { feesStructure, paymentStatus } = paymentPreview
    const { primaryApplication, additionalBranchApplications, agentApplications, referenceData } = paymentPreview

    //const [helpPanelOpen, setHelpPanelOpen] = useState(false)
    const [fetchingFeesData, setFetchingFeesData] = useState(false)
    const [showBranchPaymentConfirmation, setShowBranchPaymentConfirmation] = useState(undefined);

    /* 
     * Fetch the fees details, if not fetched already
     */
    useEffect(() => {
        if (!referenceData
            && !fetchingFeesData) {
            setFetchingFeesData(true)
            dispatch(fetchApplicationReferenceData())
                    .then(() => setFetchingFeesData(false))
        }
    },[referenceData, fetchingFeesData, dispatch])
    
    useEffect(() => {
        const allApplicationFetchRequests = []

        const addAppIfNeeded = (app) => {
            if(app?.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT && 
                !app.businessLicenceData) {
                allApplicationFetchRequests.push(dispatch(fetchApplicationWithId(app.id, true)))
            }
        }

        addAppIfNeeded(primaryApplication)
        additionalBranchApplications.forEach(branchApp => addAppIfNeeded(branchApp))
        agentApplications.forEach(agentApp => addAppIfNeeded(agentApp))
        
        if(allApplicationFetchRequests.length) {
            Promise.all(allApplicationFetchRequests)
                .then((applications) => {
                    processApplicationResponse(applications, dispatch)
                })
        }
    },[
        primaryApplication,
        additionalBranchApplications,
        agentApplications,
        dispatch
    ])
    /* event handlers */
    const onContinueClick = () => {
        dispatch(initiatePayment_v1(applicationType,applicationMode)).then(() => {
            dispatch(saveSegueDetails({
                name : SEGUE_NAME.PAYMENT,
                applicationType,
                applicationMode,
                showBranchPaymentConfirmation
            }))
            // if(applicationMode === APPLICATION_MODE_RENEW 
            //     && paymentPreview.navigation.nextRenewal) {
            //     window.sessionStorage.setItem("nextUrl",replaceUrlParams(paymentPreview.navigation.nextRenewal, applicationType, applicationMode)) 
            // } else {
            //     window.sessionStorage.setItem("nextUrl",replaceUrlParams(paymentPreview.navigation.next, applicationType, applicationMode)) 
            // }
        })     
    }

    function costBreakupTable() {
        
        if(feesStructure 
            && feesStructure[applicationType]
            && primaryApplication) {
            let agencyFeesStructure = feesStructure[applicationType]
        
            const costBreakup = computeCost(primaryApplication,
                                                additionalBranchApplications,
                                                agentApplications, 
                                                agencyFeesStructure.agencyFees,
                                                agencyFeesStructure.agencyRenewalFees,
                                                agencyFeesStructure.additionalBranchFees,
                                                agencyFeesStructure.additionalBranchFees, 
                                                agencyFeesStructure.agentFees,
                                                agencyFeesStructure.agentRenewalFees)
    
            const {licencingSubType} = primaryApplication
            const isRenewal = (licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL || 
                                licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL)

            if(showBranchPaymentConfirmation === undefined) {
                setShowBranchPaymentConfirmation(costBreakup.additionalBranchQuantity > 0 && 
                    costBreakup.agencyCost === 0 &&
                    costBreakup.agentQuantity === 0 &&
                    costBreakup.agentRenewalQuantity === 0 &&
                    costBreakup.additionalBranchRenewalQuantity === 0);
            }
            
            return (
                <div className="col-8">
                    <table className="table table-bordered costBreakupTable">
                        <thead>
                            <tr>
                                <th>Items</th>
                                <th>Cost</th>
                                <th>Qtn.</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {costBreakup.agencyCost ? <tr>
                                <th>
                                    <span style={{fontSize: "1.3em"}}>
                                        {(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) ? "Debt management agency licence"  : "Collection agency licence"}
                                        {isRenewal ? ' (renewal)' : ''}
                                        <br />
                                        (includes your first branch)
                                    </span>
                                </th>
                                <td>{"$ " + financialNumber(agencyFeesStructure.agencyFees)}</td>
                                <td>1</td>
                                <td>{"$ " + financialNumber(costBreakup.agencyCost)}</td>
                            </tr> : null }
                            {costBreakup.branchCost ? <tr>
                                <th>
                                    <span style={{fontSize: ".9em"}}>
                                        Branch licence
                                        <br />
                                        (each additional branch)
                                    </span>
                                </th>
                                <td>{"$ " + financialNumber(agencyFeesStructure.additionalBranchFees)}</td>
                                <td>{costBreakup.additionalBranchQuantity}</td>
                                <td>{"$ " + financialNumber(costBreakup.branchCost)}</td>
                            </tr> : null}
                            {costBreakup.branchRenewalCost ? <tr>
                                <th>
                                    <span style={{fontSize: ".9em"}}>
                                        Branch licence (renewal)
                                        <br />
                                        (each additional branch)
                                    </span>
                                </th>
                                <td>{"$ " + financialNumber(agencyFeesStructure.additionalBranchFees)}</td>
                                <td>{costBreakup.additionalBranchRenewalQuantity}</td>
                                <td>{"$ " + financialNumber(costBreakup.branchRenewalCost)}</td>
                            </tr> : null}
                            {costBreakup.agentCost ? <tr>
                                <th>
                                    <span style={{fontSize: "1.3em"}}>
                                        {(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) ? "Debt management agent licences" : "Collector licences"}
                                    </span>
                                </th>
                                <td>{"$ " + financialNumber(agencyFeesStructure.agentFees)}</td>
                                <td>{costBreakup.agentQuantity}</td>
                                <td>{"$ " + financialNumber(costBreakup.agentCost)}</td>
                            </tr> : null}
                            {costBreakup.agentRenewalCost ? <tr>
                                <th>
                                    <span style={{fontSize: "1.3em"}}>
                                        {(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) ? "Debt management agent licences (renewal)" : "Collector licences (renewal)"}
                                    </span>
                                </th>
                                <td>{"$ " + financialNumber(agencyFeesStructure.agentRenewalFees)}</td>
                                <td>{costBreakup.agentRenewalQuantity}</td>
                                <td>{"$ " + financialNumber(costBreakup.agentRenewalCost)}</td>
                            </tr> : null}
                            <tr>
                                <th colSpan="2">
                                    Total Cost
                                </th>
                                <td>{costBreakup.agentQuantity + costBreakup.agentRenewalQuantity + costBreakup.additionalBranchQuantity + costBreakup.additionalBranchRenewalQuantity + (costBreakup.agencyCost > 0 ? 1 : 0)}</td>
                                <td>{"$ " + financialNumber(costBreakup.agencyCost + costBreakup.branchCost + costBreakup.branchRenewalCost + costBreakup.agentCost + costBreakup.agentRenewalCost)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )
        }

       return null 
    }

    function paymentStaticText() { 
        return (
            <>
                <div className="col-8">
                <h3>Payment Options</h3>
                    <div className="bottomMarginLarge">
                        <strong>Debit Cards From : </strong>
                        <ul>
                            <li>RBC Royal Bank</li>
                            <li>TD Canada Trust</li>
                            <li>First Nations Bank of Canada</li>
                            <li>select Credit Unions</li>
                            <li>See a full list of participating banks</li>
                        </ul>
                        <ul className="fa-ul has-success">
                            <li>
                                <span className="fa-li">
                                    <i className="fa fa-check-circle fa-lg"/>
                                </span> 
                                <strong style={{paddingLeft : "15px"}}>Can use interac option to pay</strong>
                            </li>
                        </ul>
                    </div>

                    <div className="bottomMarginLarge">
                        <strong>Debit Cards with Visa or MasterCard logos : </strong>
                        <ul className="fa-ul has-success">
                            <li>
                                <span className="fa-li">
                                    <i className="fa fa-check-circle fa-lg"/>
                                </span> 
                                <strong style={{paddingLeft : "15px"}}>Can use your debit card with the credit card option to pay</strong>
                            </li>
                        </ul>
                    </div>

                    <div className="bottomMarginLarge">
                        <strong>Credit Cards From : </strong>
                        <ul>
                            <li>Visa</li>
                            <li>MasterCard</li>
                            <li>AmericanExpress</li>
                        </ul>
                        <ul className="fa-ul has-success">
                            <li>
                                <span className="fa-li">
                                    <i className="fa fa-check-circle fa-lg"/>
                                </span> 
                                <strong style={{paddingLeft : "15px"}}>Can use the credit card option to pay</strong>
                            </li>
                        </ul>
                    </div>
                </div>
            </>
        )
    }

    if(fetchingFeesData) {
        return (
            <>
                <Navigation {...props} />
                <div className={"container"}>
                    <TopNavigationBar {...props} />
                    <div className="row topMarginLarge">
                        <div className="col-12 centered">
                            <p className="statusText">
                                ...
                            </p>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
        <Navigation {...props} />
        <div className={"container"}>
            <TopNavigationBar {...props} />
            <div className="row">
                <div className="col-8">
                    <Header 
                        id="payment-preview-header"
                        header={paymentPreview.header} />
                </div>
            </div>

            <h3>Cost</h3>

            <div className="row bottomMarginNolmal">
                {costBreakupTable()}
            </div>

            <div className="row bottomMarginMedium">{paymentStaticText()}</div>

            <div className="row bottomMarginMedium">
                <div className="col-lg-2">
                    <div className={(paymentStatus === PAYMENT_STATUS_FAILURE) ? " has-error" : ""}>
                        <Button
                            id="payment-preview-continue-button" 
                            onClick = {onContinueClick}
                            text={"Continue"} 
                            showSpinner={paymentStatus === PAYMENT_STATUS_INPROGRESS}
                            buttonType={paymentStatus === PAYMENT_STATUS_INPROGRESS ? "regular_disabled" : "regular_primary"}
                        />
                        {(paymentStatus === PAYMENT_STATUS_FAILURE) && ErrorMark()}
                    </div>
                    
                </div>
                <div className="col-lg-4">
                    <NavigationLinkButton 
                        id="payment-preview-back-to-application-review"
                        buttonType="regular_primary"
                        text={"Go back to application review"}
                        onClick={() => { 
                                let url = ROUTE_PATH.APPLICATION_REVIEW
                                dispatch(push(replaceUrlParams(url, applicationType, applicationMode)))
                            }
                        }
                    />
                </div>

                {(paymentStatus === PAYMENT_STATUS_FAILURE) && (
                    <div className="col-lg-8 ns-error-message topMarginNormal">
                        <span className="ns-visually-hidden">Error:</span>
                        {ERROR_STRING.PAYMENT_PREVIEW_PAYMENT_FAIL}
                    </div>
                )}
            </div>

            {/* <div className="row">
                <div 
                    className="col-8" 
                    style={{padding: "15px", border : "1px solid #777", cursor: "pointer"}}
                    onClick={() => {
                        setHelpPanelOpen(!helpPanelOpen)
                    }}
                >
                    <strong style={{color: "#0058a4"}}>How can I use my debit card as credit card?</strong>
                    {helpPanelOpen ? <i className="fa fa-2x fa-angle-up pull-right" /> : <i className="fa fa-2x fa-angle-down pull-right" />}
                    {helpPanelOpen && 
                    <div style={{padding: "15px"}}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent posuere pulvinar sollicitudin. Maecenas euismod, turpis vel condimentum condimentum, sem felis vehicula justo, in auctor ligula velit vitae risus. Vivamus justo nisl, lobortis id dapibus nec, viverra vitae lectus. Duis et rutrum erat, id rutrum eros. Nulla sodales orci a dignissim fringilla. Interdum et malesuada fames ac ante ipsum primis in faucibus. Integer at ante in urna iaculis imperdiet quis id turpis.
                    </div>
                    }
                </div>
            </div> */}
        </div>
        </>
    )
}
export default connect(paymentPreviewSelect) (PaymentPreview)
